import { InvoicePaymentMethod } from '~core/models/invoice.models';
import { PaymentMethod } from '~core/models/payment.models';
import { ReceiptPaymentMethod } from '~core/models/receipt.models';

export function getInvoicePaymentMethods(invoice: {
  paymentMethod?: InvoicePaymentMethod;
  paymentMethods?: InvoicePaymentMethod[] | null;
}): InvoicePaymentMethod[] {
  if (invoice.paymentMethods?.length) {
    return invoice.paymentMethods;
  }

  return invoice.paymentMethod ? [invoice.paymentMethod] : [];
}

export function getInvoicePaymentMethodByPaymentMethod(
  paymentMethod: PaymentMethod | InvoicePaymentMethod | ReceiptPaymentMethod
): InvoicePaymentMethod {
  switch (paymentMethod) {
    case PaymentMethod.CREDIT_CARD:
    case PaymentMethod.TPE:
    case PaymentMethod.VISA:
    case PaymentMethod.MASTERCARD:
    case ReceiptPaymentMethod.CARD:
      return InvoicePaymentMethod.bankCard;
    case InvoicePaymentMethod.check:
      return InvoicePaymentMethod.check;
    case InvoicePaymentMethod.cash:
      return InvoicePaymentMethod.cash;
    case PaymentMethod.MOBILE_MONEY:
    case PaymentMethod.ORANGE_MONEY:
    case PaymentMethod.MTN_MONEY:
    case PaymentMethod.MOOV_MONEY:
    case PaymentMethod.WAVE_MONEY:
    case ReceiptPaymentMethod.MOBILE_MONEY:
      return InvoicePaymentMethod.mobileMoney;
    case InvoicePaymentMethod.transfer:
      return InvoicePaymentMethod.transfer;
    case InvoicePaymentMethod.eventually:
    case ReceiptPaymentMethod.DEFERRED:
      return InvoicePaymentMethod.eventually;
    default:
      return InvoicePaymentMethod.cash;
  }
}
